import React, { Component } from 'react'
import Slider from 'infinite-react-carousel';
import classes from './Carousel.module.css'
import Courses from '../Courses/Courses'

const Carousel =(props)=> {
    
    return(
        <Slider  arrows={false} dots>
      {props.children}
      </Slider>
    )
}

export default Carousel